"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allPaymentProviders = exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
  PaymentProvider["yandex"] = "Yandex";
  PaymentProvider["paypal"] = "Paypal";
  PaymentProvider["bluesnap"] = "Bluesnap";
  PaymentProvider["provider"] = "Provider";
  PaymentProvider["bank"] = "Bank";
  PaymentProvider["fondy"] = "Fondy";
})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));
exports.allPaymentProviders = [PaymentProvider.yandex, PaymentProvider.paypal, PaymentProvider.bluesnap, PaymentProvider.provider, PaymentProvider.bank, PaymentProvider.fondy];